import React from 'react';
import { Table } from 'antd';
const columns = [
  {
    title: 'User Name',
    dataIndex: 'user_name',
  },
  {
    title: 'Reason',
    dataIndex: 'reasons_reason',
  },
  {
    title: 'Activity Time',
    dataIndex: 'updated_at',
  },
];
const DownloadReasons = (props) => (
  
  <Table
    className='wday-table'
    columns={columns}
    dataSource={props.recentDownloadTeasons}
    pagination={false}
    size="small"
    scroll={{
      y: 200,
    }}
  />
);

export default DownloadReasons;

